(function () {
  var queue = [];
  var timer = null;
  var swiperLoaded = false;
  var swiperLoading = false;
  var swiperCallbacks = [];

  function loadSwiper(callback) {
    if (swiperLoaded) return callback();
    swiperCallbacks.push(callback);
    if (swiperLoading) return;
    swiperLoading = true;

    var script = document.createElement('script');
    script.src = window.DSC_ASSETS.swiper;
    script.onload = function () {
      var init = document.createElement('script');
      init.src = window.DSC_ASSETS.swiperInit;
      init.onload = function () {
        swiperLoaded = true;
        var cbs = swiperCallbacks.splice(0);
        cbs.forEach(function (cb) { cb(); });
      };
      document.head.appendChild(init);
    };
    document.head.appendChild(script);
  }

  function flushQueue() {
    timer = null;
    if (!queue.length) return;

    var batch = queue.splice(0);
    var types = [];
    var elMap = {};

    batch.forEach(function (el) {
      var t = el.getAttribute('data-section-type');
      if (t) {
        types.push(t);
        elMap[t] = el;
      }
    });

    if (!types.length) return;

    var url = window.location.pathname + '?sections=' + types.map(encodeURIComponent).join(',');

    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        types.forEach(function (type) {
          var html = data[type];
          var el = elMap[type];
          if (!html || !el) return;

          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var content = tmp.querySelector('[data-deferred-content]');
          if (!content) return;

          el.replaceWith(content);

          if (content.querySelector('swiper-container')) {
            var scope = content.closest('[id^="shopify-section-"]') || content.parentElement;
            loadSwiper(function () {
              if (window.DSC && window.DSC.initSwipers) {
                window.DSC.initSwipers(scope);
              }
            });
          }
        });
      });
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      queue.push(entry.target);
      clearTimeout(timer);
      timer = setTimeout(flushQueue, 50);
    });
  }, { rootMargin: '400px' });

  // Synchronously-rendered swiper-containers (e.g. when the section bypasses the
  // deferred skeleton because product_tag is set) still need swiper.js to load
  // and DSC.initSwipers to run on the section. Watch them and lazy-init.
  var syncObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      syncObserver.unobserve(entry.target);
      if (entry.target.swiper) return;
      var scope = entry.target.closest('[id^="shopify-section-"]') || entry.target.parentElement;
      loadSwiper(function () {
        if (window.DSC && window.DSC.initSwipers) {
          window.DSC.initSwipers(scope);
        }
      });
    });
  }, { rootMargin: '400px' });

  function init() {
    document.querySelectorAll('[data-deferred-section]').forEach(function (el) {
      observer.observe(el);
    });
    document.querySelectorAll('swiper-container').forEach(function (el) {
      if (el.closest('[data-deferred-section]')) return;
      if (el.swiper) return;
      syncObserver.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
